import { InjectionToken } from '@angular/core';

export const EXPORT_CONFIGURATION = new InjectionToken<ExportConfiguration>('exportConfiguration');

export interface ExportConfiguration {
  exportServiceUrl: string;
  restConsumerName: string;
}

export enum FileFormat {
  CSV = 'CSV',
  PDF = 'PDF',
  MICROSOFT_MONEY = 'OFX',
  QUICKEN = 'QFX'
}

export enum ContentDisposition {
  INLINE = 'INLINE'
}

export interface ExportRequest {
  exportType: string;
  exportParams?: unknown;
  fileFormat: FileFormat;
  contentDisposition?: ContentDisposition;
}

export interface ExportEvent {
  exportRequest: ExportRequest;
  restConsumerName: string;
  exportServiceUrl: string;
}
